<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title">Liste des metadatas</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <input type="text" valid="true" placeholder="Recherche" @keypress="search" @keydown="search" class="MySearch form-control">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="excelExport()">
            <span><i class="fas fa-file-csv"></i></span>
          </n-button>
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="openChooserColumnMenu()">
            <span><i class="fas fa-columns"></i></span>
          </n-button>
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addMetadata()">
            <span><i class="fas fa-plus"></i></span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <!-- Syncfusion Table here -->
          <ejs-grid ref='metadataList' id="Grid" :dataSource="tableData" :enablePersistence='false'
                    :allowReordering='true' :rowDataBound="rowDataBound"
                    :allowResizing='true'  :showColumnChooser='true'
                    :allowSelection='true' :allowPaging="true"
                    :allowSorting='true' :allowGrouping='false'
                    :editSettings='editSettings' :pageSettings='pageSettings'
                    :allowExcelExport='true' class="metadata-datagrid">
            <e-columns>
              <e-column field='key' headerText='' :visible="false" :showInColumnChooser='false' isPrimaryKey="true" textAlign='Left' width=80></e-column>
              <e-column field='name' :disableHtmlEncode="false" headerText='Nom'  textAlign='Left' width=80></e-column>
              <e-column field='options.type' headerText='Type' textAlign='Left' width=80></e-column>
              <e-column field='phase' headerText='Phase' textAlign='Left' width=80></e-column>
              <e-column field='commands' headerText=''  textAlign='Center' minWidth=40 width=40 :commands='commands'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { GridPlugin, Page, Search,  Sort, Filter, Group, ForeignKey, ExcelExport , DetailRow, ColumnChooser, Toolbar, Resize, Reorder, Edit, CommandColumn} from "@syncfusion/ej2-vue-grids";
import Spinner from "src/components/Spinner/Circle";
import Authorizable from '@/mixins/authorizable'
import moment from "moment";

export default {
  name: "MetadataList",
  mixins: [Authorizable],
  components: {
    Spinner,
  },
  data() {
    return {
      isLoaded: false,
      editSettings: { allowEditing: false, allowDeleting: true },
      // searchOptions: {fields: ['command_number', 'customer_command_number', 'detailTemplate', 'customer']},
      // dateFormat: { type: 'date', format: 'dd/MM/yyyy' },
      pageSettings: { pageSize: 15, pageSizes: true },
      commands: [{ buttonOption: { cssClass: 'e-flat', iconCss: 'e-icons', click: this.editButton} }],
      tableData: [],
      metadataList: [],
    }
  },
  provide: {
    grid: [Page, Search, ForeignKey, Sort, Filter, Group, ExcelExport, DetailRow, ColumnChooser, Resize, Reorder, Edit, CommandColumn]
  },
  mounted(){
    this.fetchData()
  },
  methods: {
    fetchData(){
      this.axios.get(process.env.VUE_APP_API_BASE_URL+`metadata/list`).catch(error => {
        this.$notify({message: "Une erreur est survenue lors du chargement des métadatas", type: 'danger', verticalAlign: 'bottom'})
      }).then( response => {
        this.tableData = response.data
        this.isLoaded = true
      })
    },
    // Redirige vers le formulaire d'édition d'une métadata
    editButton: function(args){
      var rowEle = $(args.target).parents('.e-row')
      var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
      this.$refs.metadataList.selectRow(rowIndex)
      var rowData = this.$refs.metadataList.getSelectedRecords()[0]

      this.$router.push({ name: 'Metadata Form', params: {metadata: rowData} })
    },
    // Permet de faire une recherche dans le tableau
    search: function() {
      let searchText = document.getElementsByClassName('MySearch')[0].value;
      this.$refs.metadataList.search(searchText);
    },
    // Permet d'exporter le résultat dans un tableur
    excelExport: function(args) {
      this.$refs.metadataList.excelExport();
    },
    // Ouvre la modal SyncFusion dédiée au choix des colonnes
    openChooserColumnMenu(){
      this.$refs.metadataList.openColumnChooser()
    },

    addMetadata(){
      this.$router.push({ name: 'Metadata Form' })
    },

    rowDataBound: function(args){

      var commandsColumnIndex = parseInt(this.$refs.metadataList.getColumnHeaderByField('commands').ariaColIndex)

      args.row.cells[commandsColumnIndex].firstElementChild.children[0].title = "Éditer la métadata"
      args.row.cells[commandsColumnIndex].firstElementChild.children[0].classList = "e-lib e-btn e-control e-flat e-icon-btn fas fa-edit"
      args.row.cells[commandsColumnIndex].firstElementChild.children[0].removeChild(args.row.cells[commandsColumnIndex].firstElementChild.children[0].firstElementChild)

    //   var commandColumnIndex = parseInt(this.$refs.subscriptionList.getColumnHeaderByField('commands').ariaColIndex)
    //   args.row.cells[commandColumnIndex].firstElementChild.children[0].firstElementChild.classList = "e-btn-icon fas fa-times-circle resiliation-button e-icons"
    //
    //   if(args.data.resiliation_date !== null  && args.data.resiliation_date !== undefined ){
    //     args.row.style.backgroundColor = '#f9acaa'
    //   }
    //   else{
    //     args.row.style.backgroundColor = 'rgba(255,255,255,0)'
    //   }
    //
    //   if(args.data.subscription.has_been_renew === true){
    //     args.row.style.backgroundColor = 'rgb(162, 245, 191)'
    //   }
    },
  }
}
</script>

<style>
.first-row-cell {
  font-size: 13px; margin-top: 0px; font-weight: 600
}

.second-row-cell{
  margin-top: -17px; margin-bottom: 0; font-size: 12px; font-style: italic;
}
.resiliation-button {
  font-size: 22px !important;
  color: #b7b7b7 !important;
}
</style>
